import { useEffect, useState } from "react";
import styles from "./Home.module.scss";
import { DashboardHeader, GetCash } from "../../components";
import ServicesAPI from "../../services/services";
import { storeEMITenure, storeIsLentraCustomer, storeLeadID, storeProductId, storeProductType } from "../../utils/storage";
import LoanRepayment from "../../components/GetCash/LoanRepayment";
import { useDispatch, useSelector } from "react-redux";
import { addAccountId, changeLoanApproved, setLeadStatus } from "../../redux/slices/userSlice";
import { storeCustomerTypeAndAppVersion } from "../../lib/script";
import FeedbackDrawer from "../../components/FeedbackDrawer/FeedbackDrawer";
import { fetchCredeauData } from "../../lib/credlibkit";

// import { getCustomerID } from "../../utils/storage";
import EMIRepayment from "../../components/GetCash/EMIRepayment";
import { googleEvent_HOM001 } from "../../lib/google-analytics";
import { useNavigate } from "react-router-dom";
import DisableBackButton from "../../components/DisableBackButton";
import FetchingRepayment from "../../components/GetCash/FetchingRepayment/FetchingRepayment";
import LentraDowntime from "../../components/GetCash/LentraDowntime/LentraDowntime";
import { IS_EMI_PRODUCT, SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY } from "../../Constants/constant";

const packageJson = require("../../../package.json");

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [openFeedback, setOpenFeedback] = useState(false);
  const { user, isLoanApproved } = useSelector((state) => state.user);

  const { isFeedbackRequired } = data || {};
  const dispatch = useDispatch();

  const { dashboardAPI } = new ServicesAPI();

  const navigate = useNavigate();

  // Redirect User if status is not in the excluded list
  const excludedStatuses = ["Settlement", "Disbursed", "Closed", "Part Payment", "Blacklisted"];

  const fetchAPI = async () => {
    const res = await dashboardAPI();

    if (res && res.statusCode === 200) {
      if (res.data.showStepDashboardMessages && Object?.keys(res?.data?.step).length > 0) {
        const originalData = res.data;
        const stepData = res.data.step;
        setData({ ...originalData, ...stepData });
      } else {
        setData(res.data);
      }
      const productId = res?.data?.lead?.productID || res?.data?.productID;
      localStorage.setItem(SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY, productId);
      const leadID = res?.data?.lead?.leadID;
      dispatch(setLeadStatus(res?.data?.lead?.status));
      if (leadID) {
        storeLeadID(leadID);
      } else {
        storeLeadID("");
      }

      // Store Customer Type & App Version
      storeCustomerTypeAndAppVersion(res?.data?.customer_type, packageJson.version);

      localStorage.setItem("salaryDate", res?.data?.salaryDate);

      // Redirect User for VKYC
      localStorage.setItem("transaction_id", res?.data?.redirectToVKYC?.transaction_id);
      localStorage.setItem("vkyc_status", res?.data?.redirectToVKYC?.vkyc_status);

      if (res?.data?.redirectToVKYC?.status === 1 && res?.data?.redirectToVKYC?.redirectTo === "VKYC") {
        navigate("/video-kyc");
      } else if (res?.data?.redirectToVKYC?.status === 1 && res?.data?.redirectToVKYC?.redirectTo === "AADHAAR") {
        localStorage.setItem("aadhaar_vkyc_repeat", "true");
        navigate("/select-loan");
      } else if (res?.data?.redirectToVKYC?.status === 1 && res?.data?.redirectToVKYC?.redirectTo === "VKYC_Review") {
        navigate("/video-kyc-review");
      } else if (res?.data?.redirectToVKYC?.status === 1 && res?.data?.redirectToVKYC?.redirectTo === "KFS") {
        navigate("/term-condition");
      }

      // if (excludedStatuses.includes(res?.data?.lead?.status)) {
      //   console.log("Not redirecting user");
      // } else if (res?.data?.lead?.status === "Approved Process") {
      //   dispatch(changeLoanApproved(true));
      //   navigate("/select-loan");
      // } else {
      //   navigate(res?.data?.step?.current_route ?? "/home");
      // }

      // Credeau SDK
      fetchCredeauData(localStorage.getItem("custId"));
      storeProductId(res?.data?.productId);
      storeEMITenure(res?.data?.noOfEMIs);
      storeProductType(res.data.product_type);
      storeIsLentraCustomer(res?.data?.dashboard_is_lentra_customer);
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(addAccountId(""));
    fetchAPI();

    // Events
    googleEvent_HOM001();
  }, []);

  useEffect(() => {
    setOpenFeedback(isFeedbackRequired);
  }, [isFeedbackRequired]);

  const renderContent = () => {
    if (!data || !Object.keys(data).length) return null;

    const {
      productId,
      isActuallyDisbursed,
      lead: { status },
      dashboard_is_lentra_customer,
      dasboard_isLentraPushed,
      dashboard_isLentraDownTime,
    } = data;
    const isLentraPushed = (dashboard_is_lentra_customer && !dasboard_isLentraPushed) || !dashboard_is_lentra_customer;
    const isDisbursedOrPartPayment = (status === "Disbursed" && isActuallyDisbursed) || status === "Part Payment";

    if (!isDisbursedOrPartPayment) {
      return <GetCash data={data} />;
    }

    if (dashboard_is_lentra_customer && !dasboard_isLentraPushed) {
      return <FetchingRepayment />;
    }

    if (dashboard_isLentraDownTime && dashboard_is_lentra_customer) {
      return <LentraDowntime />;
    }

    if (productId === IS_EMI_PRODUCT) {
      return <EMIRepayment />;
    }

    return <LoanRepayment data={data} />;
  };

  return (
    <>
      <DashboardHeader />

      <div className={styles.home}>
        {/* {data?.lead?.status === "Disbursed" || data?.lead?.status === "Part Payment" ? (
          <LoanRepayment data={data} />
        ) : (
          <GetCash data={data} />
        )} */}

        {renderContent()}

        {/* Our Process */}
        <div className={styles.our__process}>
          <div>
            <img src="/images/no-hidden-charge.png" alt="" />
            <p>
              No Hidden <br /> Charges
            </p>
          </div>
          <div>
            <img src="/images/quick-disbursal.png" alt="" />
            <p>
              Quick <br /> Disbursed
            </p>
          </div>
          <div>
            <img src="/images/simple-process.png" alt="" />
            <p>
              Simple & <br /> Secure Process
            </p>
          </div>
        </div>
      </div>

      {isFeedbackRequired ? (
        <FeedbackDrawer
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          onClose={() => setOpenFeedback(false)}
          user={user}
          onFeedbackSubmit={() => {
            fetchAPI();
          }}
        />
      ) : null}

      <DisableBackButton />
    </>
  );
}
